
import { ADS_MAKER_TYPE } from '../../../types/types'

class ProValidator {

  static isAccountValid(pro: any) {
    const errors = this.getAccountErrors(pro)
    return Object.keys(errors).length === 0
  }

  static getAccountErrors(pro: any) {
    const errors: any = {}
    
    // Stripe check
    const verified = pro.stripe_verified || false
    if (pro.type !== ADS_MAKER_TYPE && !verified)
      errors.stripe = 'Veuillez remplir vos informations de paiement'

    // Account Name check
    const name = pro.name
    if (!this.wasRequired(name))
      errors.name = 'Veuillez remplir votre nom de société'

    // User Name check
    const holder_name = pro.holder_name
    if (!this.wasRequired(holder_name))
      errors.holder_name = 'Ce champs est obligatoire'

    // School check
    const school = pro.school
    if (pro.type === 'asso' && !this.wasRequired(school))
      errors.school = 'Ce champs est obligatoire'
    
    // School Address check
    const address = pro.address
    const postal_code = pro.postal_code
    const city = pro.city
    if (!this.wasRequired(address))
      errors.address = 'Ce champs est obligatoire'
    if (!this.wasRequired(postal_code))
      errors.postal_code = ' '
    if (!this.wasRequired(city))
      errors.city = ' '

    // Phone check
    const phone = pro.phone
    if (!this.wasRequired(phone) || phone.split(' ').join('').length !== 10)
      errors.phone = 'Veuillez renseigner un numéro de tel valide'

    // Web check
    const web = pro.web
    if (!this.wasRequired(web))
      errors.web = 'Veuillez renseigner votre site web'
    else if (!this.isLink(web))
      errors.web = "L'URL entrée n'est pas valide"
  
    // Email check
    const email = pro.email
    if (!this.wasRequired(email))
      errors.email = 'Ce champs est obligatoire'
    else if (!email.includes('@'))
      errors.email = 'Veuillez renseigner un email de contact valide'
   
    // Accepted check
    const accepted = pro.accepted
    if (!accepted)
      errors.accepted = 'Vous devez certifier la véracité des informations'

    return errors
  }

  static wasRequired(value: any) {
    return value && value.length > 0
  }
  static wasMinimum(value: any, min: number) {
    return this.wasRequired(value) && value.length >= min
  }
  static wasMaximum(value: any, max: number) {
    return !value || value.length <= max
  }
  static isLink(link: string) {
    return link.startsWith('https://') || link.startsWith('http://')
  }
}

export default ProValidator
